// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2SvfT","topBottomGutter":"Layout_topBottomGutter__2pKgT"};